import { render } from "./orgAddModal.vue?vue&type=template&id=5f8ad3d7&ts=true"
import script from "./orgAddModal.vue?vue&type=script&lang=ts"
export * from "./orgAddModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__